
export const FETCH_REPORT_BATCHES = "FETCH_REPORT_BATCHES";
export const FETCH_REPORT_BATCHES_SUCCESS = "FETCH_REPORT_BATCHES_SUCCESS";
export const FETCH_REPORT_BATCHES_ERROR = "FETCH_REPORT_BATCHES_ERROR";


export const UPDATE_REPORT_BATCHES = "UPDATE_REPORT_BATCHES";
export const UPDATE_REPORT_BATCHES_SUCCESS = "UPDATE_REPORT_BATCHES_SUCCESS";
export const UPDATE_REPORT_BATCHES_ERROR = "UPDATE_REPORT_BATCHES_ERROR";


export const DELETE_REPORT_BATCHES = "DELETE_REPORT_BATCHES";
export const DELETE_REPORT_BATCHES_SUCCESS = "DELETE_REPORT_BATCHES_SUCCESS";
export const DELETE_REPORT_BATCHES_ERROR = "DELETE_REPORT_BATCHES_ERROR";
